export const collections = {
  users: 'accounts',
  demoAccounts: 'demo-accounts',
  companyInformation: 'company-information'
}